"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.destroyAmplifyServerContext = exports.getAmplifyServerContext = exports.createAmplifyServerContext = void 0;
var legacyServerContext_1 = require("./legacyServerContext");
Object.defineProperty(exports, "createAmplifyServerContext", { enumerable: true, get: function () { return legacyServerContext_1.createAmplifyServerContext; } });
Object.defineProperty(exports, "getAmplifyServerContext", { enumerable: true, get: function () { return legacyServerContext_1.getAmplifyServerContext; } });
Object.defineProperty(exports, "destroyAmplifyServerContext", { enumerable: true, get: function () { return legacyServerContext_1.destroyAmplifyServerContext; } });
